import RealTimeActions from 'flux/actions/RealTimeActions';
import { Map, fromJS } from 'immutable';
import TeamActions from 'flux/actions/TeamActions';

/**
 * TeamViewMixin
 *
 */
export default {
  init() {
    this._initState();

    if (this.initListeners) this.initListeners();
  },

  _initState() {
    this.setState(Map({}));
  },

  onPopulateCompleted(team) {
    this.setStateAndTrigger(fromJS(team));

    if (this.setup) this.setup();
  },

  onPopulateFailed() {
    console.log('failed to load team');
  },

  /**
   * Handle incoming real time changes
   */
  onTeamMutatedRealTime(teamId, changes) {
    if (teamId !== this.getState().get('_id')) return;

    this.mergeStateAndTrigger(fromJS(changes));
  },

  onSavePhoto(file, teamId) {
    TeamActions.updatePhoto(teamId, file);
  },

  /**
   * Update team when photo is uploaded
   */
  onUpdatePhotoCompleted(team) {
    this.mergeStateAndTrigger(fromJS(team));
  },

  onTeamUpdatePhotoRealTime(teamId, team) {
    this.mergeStateAndTrigger(fromJS(team));
  },

  /**
   * Update team
   */
  onUpdateFieldCompleted(team) {
    let state = this.getState();

    if (team._id !== state.get('_id')) return;

    this.mergeStateAndTrigger(fromJS(team));
  },

  setup() {
    RealTimeActions.subscribeToTeam(this.getState());
  },
};
